import React from 'react';
import '../../styles/AdminLoadingSpinner.css';

const AdminImageLoadingSpinner = () => (
  <div className="admin-image-loading-spinner__container">
    <div className="spinner" />
    <span className="loading-text">Loading...</span>
  </div>
);

export default AdminImageLoadingSpinner;